/* eslint-disable */
// This file contains codegen output. Run the script to update.
import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A value representing a time. Always a ISO8601 formatted string YYYY-MM-DDTHH:MM:SSZ on the wire. Clients usually infate and deflate it to native language datetime objects. */
  DateTime: { input: string; output: string; }
  HTML: { input: string; output: string; }
  InlineTml: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  Tml: { input: any; output: any; }
};

export type AggregateRating = {
  __typename?: 'AggregateRating';
  ratingValue?: Maybe<Scalars['Float']['output']>;
};

export type AnyTerms = Author | TeamTermPost | Term | TermPost;

export type Author = PostBase & {
  __typename?: 'Author';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  meta: AuthorMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taxonomy?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  term_id: Scalars['Int']['output'];
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type AuthorMeta = PostMetaBase & {
  __typename?: 'AuthorMeta';
  affiliates_enabled?: Maybe<Scalars['Boolean']['output']>;
  amazon_affiliate_tag?: Maybe<Scalars['String']['output']>;
  amazon_nca_enabled?: Maybe<Scalars['Boolean']['output']>;
  apple_news_title?: Maybe<Scalars['String']['output']>;
  archive_grid_disabled?: Maybe<Scalars['Boolean']['output']>;
  archive_grid_show_as_poster?: Maybe<Scalars['Boolean']['output']>;
  author_profile_id?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatar_focal_point?: Maybe<Point>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  featured_image_caption?: Maybe<Scalars['HTML']['output']>;
  has_comments_enabled?: Maybe<Scalars['Boolean']['output']>;
  hero_layout?: Maybe<Scalars['String']['output']>;
  hero_media_alignment?: Maybe<Scalars['String']['output']>;
  hero_preserve_image_aspect_ratio_on_mobile?: Maybe<Scalars['Boolean']['output']>;
  iab_terms_similarity?: Maybe<Array<IabTermSimilarity>>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  is_full_bleed_hero?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_apple_news?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_feed?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_google_news?: Maybe<Scalars['Boolean']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  long_description?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  monetization?: Maybe<Monetization>;
  msn_title?: Maybe<Scalars['String']['output']>;
  next_page_id?: Maybe<Scalars['Int']['output']>;
  opengraph_description?: Maybe<Scalars['String']['output']>;
  opengraph_image?: Maybe<Scalars['String']['output']>;
  opengraph_title?: Maybe<Scalars['String']['output']>;
  original_publication_timestamp?: Maybe<Scalars['DateTime']['output']>;
  page_type?: Maybe<Scalars['String']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  ph_background_image?: Maybe<Media>;
  ph_center_content?: Maybe<Scalars['Boolean']['output']>;
  ph_description?: Maybe<Scalars['String']['output']>;
  ph_show_follow_button?: Maybe<Scalars['Boolean']['output']>;
  ph_show_page_header?: Maybe<Scalars['Boolean']['output']>;
  ph_sponsored_by?: Maybe<PageHeaderSponsoredBy>;
  pinterest_url?: Maybe<Scalars['String']['output']>;
  primary_category?: Maybe<TermPost>;
  promo_description?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<Scalars['String']['output']>;
  promo_image_focal_point?: Maybe<Point>;
  promo_title?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  rss_title?: Maybe<Scalars['String']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  sponsor_logo?: Maybe<Media>;
  sponsor_url?: Maybe<Scalars['String']['output']>;
  sponsored_by?: Maybe<Scalars['String']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
  trackonomics_disabled?: Maybe<Scalars['Boolean']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  twitter_image?: Maybe<Scalars['String']['output']>;
  twitter_title?: Maybe<Scalars['String']['output']>;
  twitter_username?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yahoo_title?: Maybe<Scalars['String']['output']>;
};

export type Config = {
  __typename?: 'Config';
  config?: Maybe<Scalars['JSON']['output']>;
  schema?: Maybe<Scalars['JSON']['output']>;
};

export type ContentAffiliateTag = {
  __typename?: 'ContentAffiliateTag';
  affiliate?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type ContentArticle = ContentItem & {
  __typename?: 'ContentArticle';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  body?: Maybe<Scalars['Tml']['output']>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  reporting?: Maybe<ContentReportingConfiguration>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentArticleExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentArticleTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentAttribution = {
  __typename?: 'ContentAttribution';
  sourceName?: Maybe<Scalars['String']['output']>;
  sourcePageUrl?: Maybe<Scalars['String']['output']>;
};

export type ContentBasicPage = ContentItem & {
  __typename?: 'ContentBasicPage';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  body?: Maybe<Scalars['Tml']['output']>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentBasicPageExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentBasicPageTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentBlockItem = {
  __typename?: 'ContentBlockItem';
  blockKey?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isEndDateIndefinite?: Maybe<Scalars['Boolean']['output']>;
  isImageOnly?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<ContentItem>;
  overrideLabel?: Maybe<Scalars['String']['output']>;
  overridePromoPhoto?: Maybe<ContentPhoto>;
  overridePromoTitle?: Maybe<Scalars['String']['output']>;
  overrideTeaser?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentBrandingBadge = {
  __typename?: 'ContentBrandingBadge';
  alternativeText?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ContentPhoto>;
  linkTargetUrl?: Maybe<Scalars['String']['output']>;
};

export type ContentContributor = {
  __typename?: 'ContentContributor';
  authorProfile: ContentUserProfile;
  credit?: Maybe<Scalars['String']['output']>;
};

export type ContentEvent = ContentItem & {
  __typename?: 'ContentEvent';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  eventStatus?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['Tml']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  recap?: Maybe<Scalars['Tml']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  reporting?: Maybe<ContentReportingConfiguration>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  superEvent?: Maybe<ContentEvent>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentEventExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentEventTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentEventFilter = {
  dateRange?: InputMaybe<ContentEventFilterDateRangeCondition>;
  extension?: InputMaybe<Scalars['String']['input']>;
  /** A status field to filter on */
  status?: InputMaybe<EventStatus>;
};

export type ContentEventFilterDateRangeCondition = {
  /** A field to filter on */
  field?: InputMaybe<ContentEventFilterDateRangeConditionField>;
  /** A datetime string in the form yyyy-mm-ddThh:mm:ssZ, the result will only include items which have after or this timestamp in the specified field */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** A datetime string in the form yyyy-mm-ddThh:mm:ssZ, the result will only include items which have before or this timestamp in the specified field */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ContentEventFilterDateRangeConditionField {
  Startdate = 'STARTDATE'
}

export type ContentGallery = ContentItem & {
  __typename?: 'ContentGallery';
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  displaySettings?: Maybe<ContentGalleryDisplaySettings>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<ContentGalleryItem>>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentGalleryExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentGalleryTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentGalleryDisplaySettings = {
  __typename?: 'ContentGalleryDisplaySettings';
  showThumbnailNavigation?: Maybe<Scalars['Boolean']['output']>;
};

/** A composite type of an item and its attribution for a ContentGallery item. */
export type ContentGalleryItem = {
  __typename?: 'ContentGalleryItem';
  attribution?: Maybe<ContentGalleryItemAttribution>;
  item: ContentItem;
};

export type ContentGalleryItemAttribution = {
  __typename?: 'ContentGalleryItemAttribution';
  caption?: Maybe<Scalars['Tml']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkCommerce?: Maybe<Scalars['JSON']['output']>;
  nofollow?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
};


export type ContentGalleryItemAttributionTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentIngredient = {
  __typename?: 'ContentIngredient';
  description?: Maybe<Scalars['InlineTml']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
};


export type ContentIngredientTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentIngredientList = {
  __typename?: 'ContentIngredientList';
  ingredients?: Maybe<Array<ContentIngredient>>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ContentItem = {
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentItemExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentItemTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentItemBranding = {
  __typename?: 'ContentItemBranding';
  bottomBadge?: Maybe<ContentBrandingBadge>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  topBadge?: Maybe<ContentBrandingBadge>;
};

export type ContentItemMonetizationState = {
  __typename?: 'ContentItemMonetizationState';
  detail?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ContentItemWithFollowablesResult = {
  __typename?: 'ContentItemWithFollowablesResult';
  /** Followable ContentItems that are associated with a given ContentItem */
  followables?: Maybe<Array<ContentItem>>;
  item?: Maybe<ContentItem>;
};

export type ContentItemsResult = {
  __typename?: 'ContentItemsResult';
  items: Array<ContentItem>;
  totalResults?: Maybe<Scalars['Int']['output']>;
};

export type ContentKeywordUrl = {
  __typename?: 'ContentKeywordUrl';
  keyword?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentList = ContentItem & {
  __typename?: 'ContentList';
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<ContentListItem>>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  presets?: Maybe<ContentListComponentPresets>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentListExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentListTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentListComponentPresets = {
  __typename?: 'ContentListComponentPresets';
  heading?: Maybe<Scalars['String']['output']>;
  listCounter?: Maybe<Scalars['String']['output']>;
};

export type ContentListItem = {
  __typename?: 'ContentListItem';
  description?: Maybe<Scalars['Tml']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
};


export type ContentListItemTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentLoader = {
  filter?: InputMaybe<ContentLoaderFilter>;
  from?: InputMaybe<Scalars['Int']['input']>;
  size?: Scalars['Int']['input'];
};

export type ContentLoaderFilter = {
  filter?: InputMaybe<ContentLoaderFilterCondition>;
  sort?: InputMaybe<ContentLoaderFilterResultOrder>;
};

export type ContentLoaderFilterCondition = {
  and?: InputMaybe<Array<ContentLoaderFilterCondition>>;
  applyExcludedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<Array<Scalars['String']['input']>>;
  contentEvent?: InputMaybe<ContentEventFilter>;
  dateRange?: InputMaybe<ContentLoaderFilterDataRangeCondition>;
  embed?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeSponsored?: InputMaybe<Scalars['Boolean']['input']>;
  exclusiveContentType?: InputMaybe<Array<Scalars['String']['input']>>;
  item?: InputMaybe<Array<Scalars['String']['input']>>;
  madeWith?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ContentLoaderFilterCondition>;
  or?: InputMaybe<Array<ContentLoaderFilterCondition>>;
  parent?: InputMaybe<Array<Scalars['String']['input']>>;
  primarySection?: InputMaybe<Array<Scalars['String']['input']>>;
  syndicationChannel?: InputMaybe<SyndicationChannel>;
  term?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Includes only ContentItems that contains items embedded in TML that match the specified criteria. */
  tmlEmbed?: InputMaybe<Array<ContentLoaderFilterTmlEmbedCondition>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  vocabulary?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ContentLoaderFilterDataRangeCondition = {
  /** A field to filter on */
  field?: InputMaybe<ContentLoaderFilterDataRangeConditionField>;
  /** A datetime string in the form yyyy-mm-ddThh:mm:ssZ, the result will only include items which have after or this timestamp in the specified field */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** A datetime string in the form yyyy-mm-ddThh:mm:ssZ, the result will only include items which have before or this timestamp in the specified field */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ContentLoaderFilterDataRangeConditionField {
  Timestamp = 'TIMESTAMP',
  /** For items that have never been updated, the publication timestamp will be used. */
  UpdatedTimestamp = 'UPDATED_TIMESTAMP'
}

export enum ContentLoaderFilterResultOrder {
  Random = 'RANDOM',
  SourceRanking = 'SOURCE_RANKING',
  Timestamp = 'TIMESTAMP',
  Title = 'TITLE',
  UpdatedTimestamp = 'UPDATED_TIMESTAMP'
}

/** At least one field must be specified. */
export type ContentLoaderFilterTmlEmbedCondition = {
  externalProvider?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  itemCount?: InputMaybe<ItemCountRange>;
  path?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A union type to be used for the featuredMedia field. */
export type ContentMedia = ContentPhoto | ContentVideo;

export type ContentOrganization = ContentItem & {
  __typename?: 'ContentOrganization';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  informationRequestUrl?: Maybe<Scalars['String']['output']>;
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Scalars['Tml']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  reporting?: Maybe<ContentReportingConfiguration>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  tickerSymbol?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentOrganizationExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentOrganizationTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentPerson = ContentItem & {
  __typename?: 'ContentPerson';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  affiliations?: Maybe<Array<ContentRichTerm>>;
  alternateNames?: Maybe<Array<Scalars['String']['output']>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  astrologicalSign?: Maybe<ContentRichTerm>;
  authorProfile?: Maybe<ContentUserProfile>;
  bestKnownFor?: Maybe<Scalars['String']['output']>;
  birthCirca?: Maybe<Scalars['Boolean']['output']>;
  birthCity?: Maybe<ContentRichTerm>;
  birthCountry?: Maybe<ContentRichTerm>;
  birthDay?: Maybe<Scalars['String']['output']>;
  birthMonth?: Maybe<Scalars['String']['output']>;
  birthMonthDay?: Maybe<ContentRichTerm>;
  birthState?: Maybe<ContentRichTerm>;
  birthYear?: Maybe<ContentRichTerm>;
  birthYearCe?: Maybe<Scalars['Boolean']['output']>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  culturalAssociations?: Maybe<Array<ContentRichTerm>>;
  deathCirca?: Maybe<Scalars['Boolean']['output']>;
  deathCity?: Maybe<ContentRichTerm>;
  deathCountry?: Maybe<ContentRichTerm>;
  deathDay?: Maybe<Scalars['String']['output']>;
  deathMonth?: Maybe<Scalars['String']['output']>;
  deathMonthDay?: Maybe<ContentRichTerm>;
  deathState?: Maybe<ContentRichTerm>;
  deathYear?: Maybe<ContentRichTerm>;
  deathYearCe?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  firstName?: Maybe<ContentRichTerm>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  groups?: Maybe<Array<ContentRichTerm>>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Array<ContentRichTerm>>;
  interestingFacts?: Maybe<Array<Scalars['String']['output']>>;
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<ContentRichTerm>;
  lifeEvents?: Maybe<Array<ContentRichTerm>>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  nationalities?: Maybe<Array<ContentRichTerm>>;
  occupations?: Maybe<Array<ContentRichTerm>>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['Tml']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  quotes?: Maybe<Array<Scalars['String']['output']>>;
  referenceId?: Maybe<Scalars['String']['output']>;
  reporting?: Maybe<ContentReportingConfiguration>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  schools?: Maybe<Array<ContentRichTerm>>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentPersonExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentPersonTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentPhoto = ContentItem & {
  __typename?: 'ContentPhoto';
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  altText?: Maybe<Scalars['String']['output']>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  attribution?: Maybe<ContentAttribution>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultCaption?: Maybe<Scalars['String']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  focalPoint?: Maybe<Point>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentPhotoExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentPhotoHeightArgs = {
  profile?: InputMaybe<ImageProfile>;
};


export type ContentPhotoTmlComponentsArgs = {
  field: Scalars['String']['input'];
};


export type ContentPhotoUrlArgs = {
  preferredFormat?: InputMaybe<ImagePreferredFormat>;
  profile?: InputMaybe<ImageProfile>;
};


export type ContentPhotoWidthArgs = {
  profile?: InputMaybe<ImageProfile>;
};

export type ContentPlayer = ContentItem & {
  __typename?: 'ContentPlayer';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  reporting?: Maybe<ContentReportingConfiguration>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentPlayerExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentPlayerTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentProduct = ContentItem & {
  __typename?: 'ContentProduct';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  affiliatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  aggregateRating?: Maybe<AggregateRating>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  brand?: Maybe<Array<ContentRichTerm>>;
  branding?: Maybe<ContentItemBranding>;
  buyUrls?: Maybe<Array<Scalars['String']['output']>>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priceCurrency?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  productImage?: Maybe<ContentPhoto>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  review?: Maybe<Scalars['Tml']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  sku?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  weightUnit?: Maybe<Scalars['String']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentProductExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentProductTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentPublicationStatus = {
  __typename?: 'ContentPublicationStatus';
  absoluteUrl?: Maybe<Scalars['String']['output']>;
  originalPublicationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  publicationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  publishedByPrincipalId?: Maybe<Scalars['String']['output']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentRecipe = ContentItem & {
  __typename?: 'ContentRecipe';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  calories?: Maybe<Scalars['Float']['output']>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  carbohydrateContent?: Maybe<Scalars['Float']['output']>;
  cholesterolContent?: Maybe<Scalars['Float']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  cookTime?: Maybe<Scalars['Int']['output']>;
  cookingStyle?: Maybe<Array<ContentRichTerm>>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  fatContent?: Maybe<Scalars['Float']['output']>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  fiberContent?: Maybe<Scalars['Float']['output']>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  ingredients?: Maybe<Array<ContentIngredientList>>;
  instructions?: Maybe<Scalars['Tml']['output']>;
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  mealType?: Maybe<Array<ContentRichTerm>>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  monounsaturatedFatContent?: Maybe<Scalars['Float']['output']>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  narrative?: Maybe<Scalars['Tml']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  polyunsaturatedFatContent?: Maybe<Scalars['Float']['output']>;
  prepTime?: Maybe<Scalars['Int']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  proteinContent?: Maybe<Scalars['Float']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  recipeCuisine?: Maybe<Array<ContentRichTerm>>;
  referenceId?: Maybe<Scalars['String']['output']>;
  reporting?: Maybe<ContentReportingConfiguration>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  saturatedFatContent?: Maybe<Scalars['Float']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  servingSize?: Maybe<Scalars['String']['output']>;
  servingSizeDescription?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sodiumContent?: Maybe<Scalars['Float']['output']>;
  sugarContent?: Maybe<Scalars['Float']['output']>;
  suitableForDiet?: Maybe<Array<ContentRichTerm>>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  transFatContent?: Maybe<Scalars['Float']['output']>;
  unsaturatedFatContent?: Maybe<Scalars['Float']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentRecipeExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentRecipeTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentRedirection = {
  __typename?: 'ContentRedirection';
  sourceRelativeUrl?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  targetAbsoluteUrl?: Maybe<Scalars['String']['output']>;
};

export type ContentReference = ContentItem & {
  __typename?: 'ContentReference';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorName?: Maybe<Scalars['String']['output']>;
  authorProfile?: Maybe<ContentUserProfile>;
  authorUrl?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  publicationTime?: Maybe<Scalars['DateTime']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentReferenceExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentReferenceTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentReportingConfiguration = {
  __typename?: 'ContentReportingConfiguration';
  opportunityLineItemId?: Maybe<Scalars['String']['output']>;
  thirdPartyEventEndpoints?: Maybe<ContentReportingThirdPartyConfiguration>;
};

export type ContentReportingThirdPartyConfiguration = {
  __typename?: 'ContentReportingThirdPartyConfiguration';
  pageview?: Maybe<Array<Scalars['String']['output']>>;
};

export type ContentRichTerm = ContentItem & {
  __typename?: 'ContentRichTerm';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  contributorStatusCode?: Maybe<Scalars['String']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  hasPage?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSalishChannel?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Scalars['Tml']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ContentRichTerm>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  stampImage?: Maybe<ContentPhoto>;
  stampText?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  titleBackgroundImage?: Maybe<ContentPhoto>;
  titleImage?: Maybe<ContentPhoto>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  vocabularyKey?: Maybe<Scalars['String']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentRichTermExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentRichTermTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentSite = {
  __typename?: 'ContentSite';
  adConfig?: Maybe<Scalars['JSON']['output']>;
  basePath?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSON']['output']>;
  displayName: Scalars['String']['output'];
  experienceConfig?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  keyword: Scalars['String']['output'];
  notificationConfig?: Maybe<Scalars['JSON']['output']>;
  notificationSiteId?: Maybe<Scalars['String']['output']>;
  primaryDomain: Scalars['String']['output'];
  smartSlotConfig?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
};

export type ContentUserProfile = ContentItem & {
  __typename?: 'ContentUserProfile';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  bio?: Maybe<Scalars['Tml']['output']>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  disqusUsername?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  facebookProfileUrl?: Maybe<Scalars['String']['output']>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  googleAnalyticsTrackingId?: Maybe<Scalars['String']['output']>;
  gplusProfileUrl?: Maybe<Scalars['String']['output']>;
  hubpagesSubdomain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instagramProfileUrl?: Maybe<Scalars['String']['output']>;
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isHubpagesAdsEarningsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  pinterestProfileUrl?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  twitterUsername?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentUserProfileExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentUserProfileTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type ContentVideo = ContentItem & {
  __typename?: 'ContentVideo';
  additionalContributors?: Maybe<Array<ContentContributor>>;
  advertisingMidrollBreaks?: Maybe<Array<Scalars['Int']['output']>>;
  affiliateTags?: Maybe<Array<ContentAffiliateTag>>;
  alternatePaths?: Maybe<Array<Scalars['String']['output']>>;
  amazonNcaDisabled?: Maybe<Scalars['Boolean']['output']>;
  associatedRichTerms?: Maybe<Array<ContentRichTerm>>;
  authorProfile?: Maybe<ContentUserProfile>;
  body?: Maybe<Scalars['Tml']['output']>;
  branding?: Maybe<ContentItemBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  contentRating?: Maybe<Scalars['String']['output']>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  dek?: Maybe<Scalars['String']['output']>;
  disqusId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  embedUrl?: Maybe<Scalars['String']['output']>;
  exclusiveContentType?: Maybe<Scalars['String']['output']>;
  extendedProperty?: Maybe<ExtendedPropertyValue>;
  extension?: Maybe<Scalars['String']['output']>;
  externalReferences?: Maybe<Array<ExternalReference>>;
  featuredImageCaption?: Maybe<Scalars['InlineTml']['output']>;
  featuredMedia?: Maybe<ContentMedia>;
  forceNotification?: Maybe<Scalars['Boolean']['output']>;
  formattedTitle?: Maybe<Scalars['InlineTml']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isExcludedFromPublishedStreams?: Maybe<Scalars['Boolean']['output']>;
  isExclusiveContent?: Maybe<Scalars['Boolean']['output']>;
  isNofollow?: Maybe<Scalars['Boolean']['output']>;
  isNoindex?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSponsored?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToApp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToAppleNews?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToFeed?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleAmp?: Maybe<Scalars['Boolean']['output']>;
  isSyndicatedToGoogleNews?: Maybe<Scalars['Boolean']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  monetizationState?: Maybe<ContentItemMonetizationState>;
  msnTitle?: Maybe<Scalars['String']['output']>;
  pageTemplate?: Maybe<Scalars['JSON']['output']>;
  pageTemplateName?: Maybe<Scalars['String']['output']>;
  pathDelegationItemId?: Maybe<Scalars['String']['output']>;
  primaryImage?: Maybe<ContentPhoto>;
  primarySection?: Maybe<Array<ContentRichTerm>>;
  primarySiteId?: Maybe<Scalars['String']['output']>;
  promoFacebookImage?: Maybe<ContentPhoto>;
  promoFacebookTeaser?: Maybe<Scalars['String']['output']>;
  promoFacebookTitle?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  promoTwitterImage?: Maybe<ContentPhoto>;
  promoTwitterTeaser?: Maybe<Scalars['String']['output']>;
  promoTwitterTitle?: Maybe<Scalars['String']['output']>;
  publicationStatus?: Maybe<ContentPublicationStatus>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rssTitle?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Array<ContentRichTerm>>>;
  slug?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Array<ContentRichTerm>>;
  title?: Maybe<Scalars['String']['output']>;
  tmlComponents?: Maybe<Array<TmlFragment>>;
  tmlEmbeds?: Maybe<Array<ContentItem>>;
  trackonomicsDisabled?: Maybe<Scalars['Boolean']['output']>;
  videoPlatformCode?: Maybe<Scalars['String']['output']>;
  videoPlatformId?: Maybe<Scalars['String']['output']>;
  videoPlatformUrl?: Maybe<Scalars['String']['output']>;
  yahooTitle?: Maybe<Scalars['String']['output']>;
};


export type ContentVideoExtendedPropertyArgs = {
  name: Scalars['String']['input'];
};


export type ContentVideoTmlComponentsArgs = {
  field: Scalars['String']['input'];
};

export type DesignToken = {
  __typename?: 'DesignToken';
  css?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['JSON']['output']>;
  token?: Maybe<Scalars['JSON']['output']>;
};

export enum EventStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Delayed = 'DELAYED',
  InProgress = 'IN_PROGRESS',
  Postponed = 'POSTPONED',
  Scheduled = 'SCHEDULED'
}

/** A union type representing the extended property. */
export type ExtendedPropertyValue = ExtendedPropertyValueBoolean | ExtendedPropertyValueDateTime | ExtendedPropertyValueFloat | ExtendedPropertyValueInt | ExtendedPropertyValueItem | ExtendedPropertyValueItems | ExtendedPropertyValueString;

export type ExtendedPropertyValueBoolean = {
  __typename?: 'ExtendedPropertyValueBoolean';
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type ExtendedPropertyValueDateTime = {
  __typename?: 'ExtendedPropertyValueDateTime';
  value?: Maybe<Scalars['DateTime']['output']>;
};

export type ExtendedPropertyValueFloat = {
  __typename?: 'ExtendedPropertyValueFloat';
  value?: Maybe<Scalars['Float']['output']>;
};

export type ExtendedPropertyValueInt = {
  __typename?: 'ExtendedPropertyValueInt';
  value?: Maybe<Scalars['Int']['output']>;
};

export type ExtendedPropertyValueItem = {
  __typename?: 'ExtendedPropertyValueItem';
  value?: Maybe<ContentItem>;
};

export type ExtendedPropertyValueItems = {
  __typename?: 'ExtendedPropertyValueItems';
  value?: Maybe<Array<ContentItem>>;
};

export type ExtendedPropertyValueString = {
  __typename?: 'ExtendedPropertyValueString';
  value?: Maybe<Scalars['String']['output']>;
};

export type ExternalReference = {
  __typename?: 'ExternalReference';
  id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type ExternalVideo = {
  __typename?: 'ExternalVideo';
  embed_url: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type Html_Sitemap_Range_Date = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export enum Html_Sitemap_Range_Type {
  Date = 'DATE',
  LastWeek = 'LAST_WEEK',
  ThisWeek = 'THIS_WEEK',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export type IabTermSimilarity = {
  __typename?: 'IabTermSimilarity';
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  sim?: Maybe<Scalars['Float']['output']>;
};

export enum ImagePreferredFormat {
  Jpg = 'JPG'
}

export enum ImageProfile {
  AppLandscapeCompact = 'APP_LANDSCAPE_COMPACT',
  AppLandscapeCompactFixedAspect = 'APP_LANDSCAPE_COMPACT_FIXED_ASPECT',
  AppLandscapeRegular = 'APP_LANDSCAPE_REGULAR',
  AppLandscapeRegularFixedAspect = 'APP_LANDSCAPE_REGULAR_FIXED_ASPECT',
  AppPortraitCompact = 'APP_PORTRAIT_COMPACT',
  AppPortraitCompactFixedAspect = 'APP_PORTRAIT_COMPACT_FIXED_ASPECT',
  AppPortraitRegular = 'APP_PORTRAIT_REGULAR',
  AppPortraitRegularFixedAspect = 'APP_PORTRAIT_REGULAR_FIXED_ASPECT',
  Favicon = 'FAVICON',
  Large = 'LARGE',
  LargeFixedAspect = 'LARGE_FIXED_ASPECT',
  Medium = 'MEDIUM',
  MediumFixedAspect = 'MEDIUM_FIXED_ASPECT',
  Original = 'ORIGINAL',
  RssDefault = 'RSS_DEFAULT',
  RssYahooFinance = 'RSS_YAHOO_FINANCE',
  SizeA = 'SIZE_A',
  Small = 'SMALL',
  SmallFixedAspect = 'SMALL_FIXED_ASPECT',
  TeamLogo = 'TEAM_LOGO',
  Tiny = 'TINY',
  TinyFixedAspect = 'TINY_FIXED_ASPECT'
}

export type ItemCountRange = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type LeftRail = PostBase & {
  __typename?: 'LeftRail';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: PostMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type Media = PostBase & {
  __typename?: 'Media';
  alt_text?: Maybe<Scalars['String']['output']>;
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  caption?: Maybe<Scalars['HTML']['output']>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  img_src_name?: Maybe<Scalars['String']['output']>;
  img_src_url?: Maybe<Scalars['String']['output']>;
  media_details?: Maybe<MediaDetails>;
  meta?: Maybe<MediaMeta>;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type MediaDetails = {
  __typename?: 'MediaDetails';
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediaMeta = {
  __typename?: 'MediaMeta';
  focal_point?: Maybe<Point>;
  page_type?: Maybe<Scalars['String']['output']>;
  source_name?: Maybe<Scalars['String']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
};

export enum Monetization {
  Demonetized = 'demonetized',
  DirectOnly = 'direct_only',
  Monetizable = 'monetizable'
}

export type Newsletter = PostBase & {
  __typename?: 'Newsletter';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: NewsletterMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type NewsletterMeta = PostMetaBase & {
  __typename?: 'NewsletterMeta';
  affiliates_enabled?: Maybe<Scalars['Boolean']['output']>;
  amazon_affiliate_tag?: Maybe<Scalars['String']['output']>;
  amazon_nca_enabled?: Maybe<Scalars['Boolean']['output']>;
  apple_news_title?: Maybe<Scalars['String']['output']>;
  author_profile_id?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured_image_caption?: Maybe<Scalars['HTML']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  has_comments_enabled?: Maybe<Scalars['Boolean']['output']>;
  hero_layout?: Maybe<Scalars['String']['output']>;
  hero_media_alignment?: Maybe<Scalars['String']['output']>;
  hero_preserve_image_aspect_ratio_on_mobile?: Maybe<Scalars['Boolean']['output']>;
  iab_terms_similarity?: Maybe<Array<IabTermSimilarity>>;
  image_url?: Maybe<Scalars['String']['output']>;
  is_full_bleed_hero?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_apple_news?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_feed?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_google_news?: Maybe<Scalars['Boolean']['output']>;
  message_type_id?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  monetization?: Maybe<Monetization>;
  msn_title?: Maybe<Scalars['String']['output']>;
  next_page_id?: Maybe<Scalars['Int']['output']>;
  opengraph_description?: Maybe<Scalars['String']['output']>;
  opengraph_image?: Maybe<Scalars['String']['output']>;
  opengraph_title?: Maybe<Scalars['String']['output']>;
  original_publication_timestamp?: Maybe<Scalars['DateTime']['output']>;
  page_type?: Maybe<Scalars['String']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  ph_background_image?: Maybe<Media>;
  ph_center_content?: Maybe<Scalars['Boolean']['output']>;
  ph_description?: Maybe<Scalars['String']['output']>;
  ph_show_follow_button?: Maybe<Scalars['Boolean']['output']>;
  ph_show_page_header?: Maybe<Scalars['Boolean']['output']>;
  ph_sponsored_by?: Maybe<PageHeaderSponsoredBy>;
  primary_category?: Maybe<TermPost>;
  product_item_id?: Maybe<Scalars['String']['output']>;
  promo_description?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<Scalars['String']['output']>;
  promo_image_focal_point?: Maybe<Point>;
  promo_title?: Maybe<Scalars['String']['output']>;
  rss_title?: Maybe<Scalars['String']['output']>;
  sponsor_logo?: Maybe<Media>;
  sponsor_url?: Maybe<Scalars['String']['output']>;
  sponsored_by?: Maybe<Scalars['String']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
  trackonomics_disabled?: Maybe<Scalars['Boolean']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  twitter_image?: Maybe<Scalars['String']['output']>;
  twitter_title?: Maybe<Scalars['String']['output']>;
  yahoo_title?: Maybe<Scalars['String']['output']>;
};

export type Numbrix = PostBase & {
  __typename?: 'Numbrix';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: PostMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type Page = PostBase & {
  __typename?: 'Page';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: PostMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type PageHeaderSponsoredBy = {
  __typename?: 'PageHeaderSponsoredBy';
  opens_in_new_tab?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Point = {
  __typename?: 'Point';
  x?: Maybe<Scalars['Int']['output']>;
  y?: Maybe<Scalars['Int']['output']>;
};

export type Post = PostBase & {
  __typename?: 'Post';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: PostMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type PostBase = {
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type PostConnection = {
  __typename?: 'PostConnection';
  edges: Array<PostEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type PostEdge = {
  __typename?: 'PostEdge';
  node: PostBase;
};

export type PostMeta = PostMetaBase & {
  __typename?: 'PostMeta';
  affiliates_enabled?: Maybe<Scalars['Boolean']['output']>;
  amazon_affiliate_tag?: Maybe<Scalars['String']['output']>;
  amazon_nca_enabled?: Maybe<Scalars['Boolean']['output']>;
  apple_news_title?: Maybe<Scalars['String']['output']>;
  archive_grid_disabled?: Maybe<Scalars['Boolean']['output']>;
  archive_grid_show_as_poster?: Maybe<Scalars['Boolean']['output']>;
  author_profile_id?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  featured_image_caption?: Maybe<Scalars['HTML']['output']>;
  featured_video?: Maybe<VideoOrExternalVideo>;
  has_comments_enabled?: Maybe<Scalars['Boolean']['output']>;
  hero_layout?: Maybe<Scalars['String']['output']>;
  hero_media_alignment?: Maybe<Scalars['String']['output']>;
  hero_preserve_image_aspect_ratio_on_mobile?: Maybe<Scalars['Boolean']['output']>;
  hide_author_from_article?: Maybe<Scalars['Boolean']['output']>;
  iab_terms_similarity?: Maybe<Array<IabTermSimilarity>>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  is_full_bleed_hero?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_apple_news?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_feed?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_google_news?: Maybe<Scalars['Boolean']['output']>;
  left_rail_post_id?: Maybe<Scalars['Int']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  listing_featured_video?: Maybe<Video>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  monetization?: Maybe<Monetization>;
  msn_title?: Maybe<Scalars['String']['output']>;
  next_page_id?: Maybe<Scalars['Int']['output']>;
  opengraph_description?: Maybe<Scalars['String']['output']>;
  opengraph_image?: Maybe<Scalars['String']['output']>;
  opengraph_title?: Maybe<Scalars['String']['output']>;
  original_publication_timestamp?: Maybe<Scalars['DateTime']['output']>;
  page_type?: Maybe<Scalars['String']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  ph_background_image?: Maybe<Media>;
  ph_center_content?: Maybe<Scalars['Boolean']['output']>;
  ph_decorative_element?: Maybe<Scalars['String']['output']>;
  ph_decorative_element_alignment?: Maybe<Scalars['String']['output']>;
  ph_description?: Maybe<Scalars['String']['output']>;
  ph_show_as_profile_bio?: Maybe<Scalars['Boolean']['output']>;
  ph_show_follow_button?: Maybe<Scalars['Boolean']['output']>;
  ph_show_page_header?: Maybe<Scalars['Boolean']['output']>;
  ph_sponsored_by?: Maybe<PageHeaderSponsoredBy>;
  ph_team_organization?: Maybe<Scalars['String']['output']>;
  pinterest_url?: Maybe<Scalars['String']['output']>;
  primary_category?: Maybe<TermPost>;
  promo_description?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<Scalars['String']['output']>;
  promo_image_focal_point?: Maybe<Point>;
  promo_title?: Maybe<Scalars['String']['output']>;
  rss_title?: Maybe<Scalars['String']['output']>;
  show_contributor_bios?: Maybe<Scalars['Boolean']['output']>;
  sponsor_logo?: Maybe<Media>;
  sponsor_url?: Maybe<Scalars['String']['output']>;
  sponsored_by?: Maybe<Scalars['String']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
  trackonomics_disabled?: Maybe<Scalars['Boolean']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  twitter_image?: Maybe<Scalars['String']['output']>;
  twitter_title?: Maybe<Scalars['String']['output']>;
  twitter_username?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yahoo_title?: Maybe<Scalars['String']['output']>;
};

export type PostMetaBase = {
  affiliates_enabled?: Maybe<Scalars['Boolean']['output']>;
  amazon_affiliate_tag?: Maybe<Scalars['String']['output']>;
  amazon_nca_enabled?: Maybe<Scalars['Boolean']['output']>;
  apple_news_title?: Maybe<Scalars['String']['output']>;
  author_profile_id?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  featured_image_caption?: Maybe<Scalars['HTML']['output']>;
  has_comments_enabled?: Maybe<Scalars['Boolean']['output']>;
  hero_layout?: Maybe<Scalars['String']['output']>;
  hero_media_alignment?: Maybe<Scalars['String']['output']>;
  hero_preserve_image_aspect_ratio_on_mobile?: Maybe<Scalars['Boolean']['output']>;
  iab_terms_similarity?: Maybe<Array<IabTermSimilarity>>;
  is_full_bleed_hero?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_apple_news?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_feed?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_google_news?: Maybe<Scalars['Boolean']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  monetization?: Maybe<Monetization>;
  msn_title?: Maybe<Scalars['String']['output']>;
  next_page_id?: Maybe<Scalars['Int']['output']>;
  opengraph_description?: Maybe<Scalars['String']['output']>;
  opengraph_image?: Maybe<Scalars['String']['output']>;
  opengraph_title?: Maybe<Scalars['String']['output']>;
  original_publication_timestamp?: Maybe<Scalars['DateTime']['output']>;
  page_type?: Maybe<Scalars['String']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  ph_background_image?: Maybe<Media>;
  ph_center_content?: Maybe<Scalars['Boolean']['output']>;
  ph_description?: Maybe<Scalars['String']['output']>;
  ph_show_follow_button?: Maybe<Scalars['Boolean']['output']>;
  ph_show_page_header?: Maybe<Scalars['Boolean']['output']>;
  ph_sponsored_by?: Maybe<PageHeaderSponsoredBy>;
  primary_category?: Maybe<TermPost>;
  promo_description?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<Scalars['String']['output']>;
  promo_image_focal_point?: Maybe<Point>;
  promo_title?: Maybe<Scalars['String']['output']>;
  rss_title?: Maybe<Scalars['String']['output']>;
  sponsor_logo?: Maybe<Media>;
  sponsor_url?: Maybe<Scalars['String']['output']>;
  sponsored_by?: Maybe<Scalars['String']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
  trackonomics_disabled?: Maybe<Scalars['Boolean']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  twitter_image?: Maybe<Scalars['String']['output']>;
  twitter_title?: Maybe<Scalars['String']['output']>;
  yahoo_title?: Maybe<Scalars['String']['output']>;
};

export type PostsFilter = {
  orderby?: InputMaybe<PostsFilterSort>;
  search?: InputMaybe<PostsFilterSearchQuery>;
  where?: InputMaybe<PostsFilterWhere>;
};

export type PostsFilterDateRange = {
  /** A field to filter on */
  field: PostsFilterDateRangeTimestampField;
  /** A datetime string in the form yyyy-mm-ddThh:mm:ss, the result will only include items which have after or this timestamp in the specified field */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** A datetime string in the form yyyy-mm-ddThh:mm:ss, the result will only include items which have before or this timestamp in the specified field */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum PostsFilterDateRangeTimestampField {
  DateGmt = 'date_gmt',
  ModifiedGmt = 'modified_gmt'
}

export enum PostsFilterSearchProfile {
  /** For basic full-text searches on the CMS. Text match and article freshness are prioritized. */
  CmsSearch = 'CMS_SEARCH',
  /** For basic full-text searches on the site. Text match and article freshness are prioritized. */
  SiteSearch = 'SITE_SEARCH'
}

export type PostsFilterSearchQuery = {
  profile: PostsFilterSearchProfile;
  query: Scalars['String']['input'];
};

export type PostsFilterSort = {
  field?: PostsFilterSortBy;
  order?: PostsFilterSortOrder;
};

export enum PostsFilterSortBy {
  DateGmt = 'date_gmt',
  ModifiedGmt = 'modified_gmt',
  OriginalPublicationTimestamp = 'original_publication_timestamp',
  PostId = 'post_id',
  Score = 'score',
  Title = 'title'
}

export enum PostsFilterSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum PostsFilterSyndication {
  AppleNews = 'APPLE_NEWS',
  Feed = 'FEED',
  GoogleNews = 'GOOGLE_NEWS'
}

export type PostsFilterWhere = {
  /** Retrieve posts that match all of the conditions. */
  and?: InputMaybe<Array<PostsFilterWhere>>;
  /** Retrieve posts that are authored by any of the specified authors (GUID). */
  author?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts that are authored by any of the specified authors (term_id). */
  authorId?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateRange?: InputMaybe<PostsFilterDateRange>;
  /** Retrieve non-sponsored posts. */
  excludeSponsored?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retrieve the posts with the specified GUID. */
  guid?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts for which one of the specified monetization status. */
  monetization?: InputMaybe<Array<Monetization>>;
  /** Retrieve posts that do not match the conditions. */
  not?: InputMaybe<PostsFilterWhere>;
  /** Retrieve posts that match any of the conditions. */
  or?: InputMaybe<Array<PostsFilterWhere>>;
  /** Retrieve posts that are owned by any of the specified users (user id). */
  ownerId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Retrieve posts matching the specified page type. */
  pageType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts matching the specified path. */
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve the posts with the specified post ID. */
  postId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Retrieve posts matching the specified post type. */
  postType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts that are tied to one of the specified categories (GUID) as the primary category. */
  primaryCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts that are tied to one of the specified categories (term_id) as the primary category. */
  primaryCategoryId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Retrieve posts matching the specified site ID. */
  siteId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Retrieve posts matching the specified slug. */
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts matching the specified status. */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts for which one of the specified syndication channels is enabled. */
  syndication?: InputMaybe<Array<PostsFilterSyndication>>;
  /** Retrieve posts that are associated with any of the specified terms (GUID). */
  term?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve posts that are associated with any of the specified terms (term_id). */
  termId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Query = {
  __typename?: 'Query';
  /** Fetch a named config for a site. This must be executed under the specific site context. */
  config?: Maybe<Config>;
  /** Fetch ContentBlockItems that are programmed at the time of querying for the given block keys. This must be executed under the specific site context. */
  contentBlockItems: Array<ContentBlockItem>;
  /** Fetch a single ContentItem. This must be executed under the specific site context. */
  contentItem?: Maybe<ContentItem>;
  /** Fetch a single ContentItem and its associated followable items */
  contentItemWithFollowables?: Maybe<ContentItemWithFollowablesResult>;
  /** Fetch multiple ContentItems. This must be executed under the specific site context. */
  contentItems?: Maybe<ContentItemsResult>;
  /** Fetch the current ContentSiteConfig. This must be executed under the specific site context. */
  contentSite?: Maybe<ContentSite>;
  /** Fetch design tokens for a site. This must be executed under the specific site context. */
  designTokens?: Maybe<DesignToken>;
  /** Returns index for HTML sitemap at specified base time */
  htmlSitemapIndex: Array<Scalars['Int']['output']>;
  /** Returns posts that fall within the specified time range. Optimized for HTML sitemap generation, data for most fields is not available. */
  htmlSitemapPosts: Array<PostBase>;
  posts: PostConnection;
  terms: TermConnection;
  /** Fetch multiple ContentItems from all sites. The service role is required to execute this query. */
  universalContentItems?: Maybe<ContentItemsResult>;
  xmlSitemapIndex: Array<Sitemap>;
  xmlSitemapPosts: Array<PostBase>;
};


export type QueryConfigArgs = {
  name: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type QueryContentBlockItemsArgs = {
  blockKeys: Array<Scalars['String']['input']>;
};


export type QueryContentItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentItemWithFollowablesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentItemsArgs = {
  loader: ContentLoader;
};


export type QueryContentSiteArgs = {
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDesignTokensArgs = {
  version: Scalars['Int']['input'];
};


export type QueryHtmlSitemapIndexArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  siteId: Array<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHtmlSitemapPostsArgs = {
  date?: InputMaybe<Html_Sitemap_Range_Date>;
  siteId: Array<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
  type: Html_Sitemap_Range_Type;
};


export type QueryPostsArgs = {
  filter: PostsFilter;
  first?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryTermsArgs = {
  filter: TermsFilter;
  first?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryUniversalContentItemsArgs = {
  loader: ContentLoader;
  searchTarget: SearchTarget;
};


export type QueryXmlSitemapIndexArgs = {
  siteId: Array<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
};


export type QueryXmlSitemapPostsArgs = {
  loc: Scalars['String']['input'];
  siteId: Array<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
};

export type Recipe = PostBase & {
  __typename?: 'Recipe';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: RecipeMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type RecipeMeta = PostMetaBase & {
  __typename?: 'RecipeMeta';
  affiliates_enabled?: Maybe<Scalars['Boolean']['output']>;
  amazon_affiliate_tag?: Maybe<Scalars['String']['output']>;
  amazon_nca_enabled?: Maybe<Scalars['Boolean']['output']>;
  apple_news_title?: Maybe<Scalars['String']['output']>;
  author_profile_id?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  calories?: Maybe<Scalars['Float']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  carbohydrate_content?: Maybe<Scalars['Float']['output']>;
  cholesterol_content?: Maybe<Scalars['Float']['output']>;
  cook_time?: Maybe<Scalars['Int']['output']>;
  fat_content?: Maybe<Scalars['Float']['output']>;
  featured_image_caption?: Maybe<Scalars['HTML']['output']>;
  fiber_content?: Maybe<Scalars['Float']['output']>;
  has_comments_enabled?: Maybe<Scalars['Boolean']['output']>;
  hero_layout?: Maybe<Scalars['String']['output']>;
  hero_media_alignment?: Maybe<Scalars['String']['output']>;
  hero_preserve_image_aspect_ratio_on_mobile?: Maybe<Scalars['Boolean']['output']>;
  hide_author_from_article?: Maybe<Scalars['Boolean']['output']>;
  iab_terms_similarity?: Maybe<Array<IabTermSimilarity>>;
  is_full_bleed_hero?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_apple_news?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_feed?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_google_news?: Maybe<Scalars['Boolean']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  monetization?: Maybe<Monetization>;
  monounsaturated_fat_content?: Maybe<Scalars['Float']['output']>;
  msn_title?: Maybe<Scalars['String']['output']>;
  next_page_id?: Maybe<Scalars['Int']['output']>;
  opengraph_description?: Maybe<Scalars['String']['output']>;
  opengraph_image?: Maybe<Scalars['String']['output']>;
  opengraph_title?: Maybe<Scalars['String']['output']>;
  original_publication_timestamp?: Maybe<Scalars['DateTime']['output']>;
  page_type?: Maybe<Scalars['String']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  ph_background_image?: Maybe<Media>;
  ph_center_content?: Maybe<Scalars['Boolean']['output']>;
  ph_description?: Maybe<Scalars['String']['output']>;
  ph_show_follow_button?: Maybe<Scalars['Boolean']['output']>;
  ph_show_page_header?: Maybe<Scalars['Boolean']['output']>;
  ph_sponsored_by?: Maybe<PageHeaderSponsoredBy>;
  polyunsaturated_fat_content?: Maybe<Scalars['Float']['output']>;
  prep_time?: Maybe<Scalars['Int']['output']>;
  primary_category?: Maybe<TermPost>;
  promo_description?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<Scalars['String']['output']>;
  promo_image_focal_point?: Maybe<Point>;
  promo_title?: Maybe<Scalars['String']['output']>;
  protein_content?: Maybe<Scalars['Float']['output']>;
  rss_title?: Maybe<Scalars['String']['output']>;
  saturated_fat_content?: Maybe<Scalars['Float']['output']>;
  serving_size?: Maybe<Scalars['String']['output']>;
  servings?: Maybe<Scalars['String']['output']>;
  show_contributor_bios?: Maybe<Scalars['Boolean']['output']>;
  show_jump_to_button?: Maybe<Scalars['Boolean']['output']>;
  sodium_content?: Maybe<Scalars['Float']['output']>;
  sponsor_logo?: Maybe<Media>;
  sponsor_url?: Maybe<Scalars['String']['output']>;
  sponsored_by?: Maybe<Scalars['String']['output']>;
  sugar_content?: Maybe<Scalars['Float']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
  total_time?: Maybe<Scalars['Int']['output']>;
  trackonomics_disabled?: Maybe<Scalars['Boolean']['output']>;
  trans_fat_content?: Maybe<Scalars['Float']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  twitter_image?: Maybe<Scalars['String']['output']>;
  twitter_title?: Maybe<Scalars['String']['output']>;
  unsaturated_fat_content?: Maybe<Scalars['Float']['output']>;
  yahoo_title?: Maybe<Scalars['String']['output']>;
};

export type SearchTarget = {
  hubpages?: InputMaybe<Scalars['Boolean']['input']>;
  notificationGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  siteKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  siteSets?: InputMaybe<Array<SiteSet>>;
  verticals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SiteSet = {
  name: Scalars['String']['input'];
  siteKeyword: Scalars['String']['input'];
};

export type Sitemap = {
  __typename?: 'Sitemap';
  lastModified: Scalars['DateTime']['output'];
  loc: Scalars['String']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum SyndicationChannel {
  App = 'APP',
  Feed = 'FEED',
  GoogleNews = 'GOOGLE_NEWS'
}

export type TeamTermPost = PostBase & {
  __typename?: 'TeamTermPost';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: TeamTermPostMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<TeamTermPost>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taxonomy?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
  term_id: Scalars['Int']['output'];
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type TeamTermPostMeta = PostMetaBase & {
  __typename?: 'TeamTermPostMeta';
  affiliates_enabled?: Maybe<Scalars['Boolean']['output']>;
  amazon_affiliate_tag?: Maybe<Scalars['String']['output']>;
  amazon_nca_enabled?: Maybe<Scalars['Boolean']['output']>;
  apple_news_title?: Maybe<Scalars['String']['output']>;
  author_profile_id?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  community_url?: Maybe<Scalars['String']['output']>;
  featured_image_caption?: Maybe<Scalars['HTML']['output']>;
  has_comments_enabled?: Maybe<Scalars['Boolean']['output']>;
  hero_layout?: Maybe<Scalars['String']['output']>;
  hero_media_alignment?: Maybe<Scalars['String']['output']>;
  hero_preserve_image_aspect_ratio_on_mobile?: Maybe<Scalars['Boolean']['output']>;
  iab_terms_similarity?: Maybe<Array<IabTermSimilarity>>;
  is_full_bleed_hero?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_apple_news?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_feed?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_google_news?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  monetization?: Maybe<Monetization>;
  msn_title?: Maybe<Scalars['String']['output']>;
  nation_site_name?: Maybe<Scalars['String']['output']>;
  next_page_id?: Maybe<Scalars['Int']['output']>;
  opengraph_description?: Maybe<Scalars['String']['output']>;
  opengraph_image?: Maybe<Scalars['String']['output']>;
  opengraph_title?: Maybe<Scalars['String']['output']>;
  original_publication_timestamp?: Maybe<Scalars['DateTime']['output']>;
  page_type?: Maybe<Scalars['String']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  ph_background_image?: Maybe<Media>;
  ph_center_content?: Maybe<Scalars['Boolean']['output']>;
  ph_description?: Maybe<Scalars['String']['output']>;
  ph_show_follow_button?: Maybe<Scalars['Boolean']['output']>;
  ph_show_page_header?: Maybe<Scalars['Boolean']['output']>;
  ph_sponsored_by?: Maybe<PageHeaderSponsoredBy>;
  primary_category?: Maybe<TermPost>;
  promo_description?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<Scalars['String']['output']>;
  promo_image_focal_point?: Maybe<Point>;
  promo_title?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  rss_title?: Maybe<Scalars['String']['output']>;
  sponsor_logo?: Maybe<Media>;
  sponsor_url?: Maybe<Scalars['String']['output']>;
  sponsored_by?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Scalars['String']['output']>;
  subleague?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['ID']['output']>;
  team_uuid?: Maybe<Scalars['ID']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
  trackonomics_disabled?: Maybe<Scalars['Boolean']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  twitter_image?: Maybe<Scalars['String']['output']>;
  twitter_title?: Maybe<Scalars['String']['output']>;
  yahoo_title?: Maybe<Scalars['String']['output']>;
};

export type Term = {
  __typename?: 'Term';
  description?: Maybe<Scalars['String']['output']>;
  guid: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Term>;
  path?: Maybe<Scalars['String']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  taxonomy?: Maybe<Scalars['String']['output']>;
  term_id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type TermConnection = {
  __typename?: 'TermConnection';
  edges: Array<TermEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type TermEdge = {
  __typename?: 'TermEdge';
  node: AnyTerms;
};

export type TermPost = PostBase & {
  __typename?: 'TermPost';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: PostMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<TermPost>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taxonomy?: Maybe<Scalars['String']['output']>;
  team?: Maybe<TeamTermPost>;
  template?: Maybe<Scalars['String']['output']>;
  term_id: Scalars['Int']['output'];
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
};

export type TermPostOrTerm = Term | TermPost;

export type TermsFilter = {
  orderby?: InputMaybe<TermsFilterSort>;
  where?: InputMaybe<TermsFilterWhere>;
};

export type TermsFilterSort = {
  field?: TermsFilterSortBy;
  order?: TermsFilterSortOrder;
};

export enum TermsFilterSortBy {
  Name = 'name',
  /** Sort by the term ID of the parent term */
  Parent = 'parent',
  Score = 'score',
  Slug = 'slug'
}

export enum TermsFilterSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type TermsFilterWhere = {
  /** Retrieve terms that match all of the conditions. */
  and?: InputMaybe<Array<TermsFilterWhere>>;
  /** Retrieve the terms with the specified GUID. */
  guid?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve terms that do not match the conditions. */
  not?: InputMaybe<TermsFilterWhere>;
  /** Retrieve terms that match any of the conditions. */
  or?: InputMaybe<Array<TermsFilterWhere>>;
  /** Retrieve terms with the specified ID as its parent. */
  parentTermId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Retrieve terms that matches the specified keywords. Multiple keywords are used to narrow down the search. Condition nested inside "and", "or", or "not" do not contribute to the score. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Retrieve terms matching the specified site ID. */
  siteId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Retrieve terms matching the specified slug. */
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve terms matching the specified taxonomy. */
  taxonomy?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retrieve terms with the specified term ID. */
  termId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Retrieve terms matching the specified term type. */
  termType?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TmlFragment = {
  __typename?: 'TmlFragment';
  /** An array containing a name-value pair of html attributes. */
  attributes?: Maybe<Array<TmlFragmentAttribute>>;
  /** An HTML content for some fragment types. */
  content?: Maybe<Scalars['String']['output']>;
  /** A ContentItem object for the embed type. */
  item?: Maybe<ContentItem>;
  /** A ParsedTml for some inline fragment types. */
  parsedContent?: Maybe<Scalars['JSON']['output']>;
  /** A type of TML fragment which can be quote, code, embed, headingN, paragraph, pullquote, toc, or html. */
  type: Scalars['String']['output'];
};

export type TmlFragmentAttribute = {
  __typename?: 'TmlFragmentAttribute';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Video = PostBase & {
  __typename?: 'Video';
  article_type_slug?: Maybe<Scalars['String']['output']>;
  authors: Array<Author>;
  auto_play_muted?: Maybe<Scalars['Boolean']['output']>;
  comment_status?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['HTML']['output']>;
  date_gmt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featured_media?: Maybe<Media>;
  guid: Scalars['ID']['output'];
  meta: VideoMeta;
  modified_gmt: Scalars['DateTime']['output'];
  owner_id?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<PostBase>;
  path?: Maybe<Scalars['String']['output']>;
  post_id: Scalars['Int']['output'];
  schema?: Maybe<Scalars['JSON']['output']>;
  site_id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  template?: Maybe<Scalars['String']['output']>;
  terms: Array<TermPostOrTerm>;
  title?: Maybe<Scalars['HTML']['output']>;
  type: Scalars['String']['output'];
  video_title?: Maybe<Scalars['HTML']['output']>;
};

export type VideoMeta = PostMetaBase & {
  __typename?: 'VideoMeta';
  affiliates_enabled?: Maybe<Scalars['Boolean']['output']>;
  amazon_affiliate_tag?: Maybe<Scalars['String']['output']>;
  amazon_nca_enabled?: Maybe<Scalars['Boolean']['output']>;
  apple_news_title?: Maybe<Scalars['String']['output']>;
  author_profile_id?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  brand_logo?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  embed_url?: Maybe<Scalars['String']['output']>;
  featured_image_caption?: Maybe<Scalars['HTML']['output']>;
  has_comments_enabled?: Maybe<Scalars['Boolean']['output']>;
  hero_layout?: Maybe<Scalars['String']['output']>;
  hero_media_alignment?: Maybe<Scalars['String']['output']>;
  hero_preserve_image_aspect_ratio_on_mobile?: Maybe<Scalars['Boolean']['output']>;
  hide_author_from_article?: Maybe<Scalars['Boolean']['output']>;
  iab_terms_similarity?: Maybe<Array<IabTermSimilarity>>;
  is_full_bleed_hero?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_apple_news?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_feed?: Maybe<Scalars['Boolean']['output']>;
  is_syndicated_to_google_news?: Maybe<Scalars['Boolean']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_robots?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  monetization?: Maybe<Monetization>;
  msn_title?: Maybe<Scalars['String']['output']>;
  next_page_id?: Maybe<Scalars['Int']['output']>;
  opengraph_description?: Maybe<Scalars['String']['output']>;
  opengraph_image?: Maybe<Scalars['String']['output']>;
  opengraph_title?: Maybe<Scalars['String']['output']>;
  original_publication_timestamp?: Maybe<Scalars['DateTime']['output']>;
  page_type?: Maybe<Scalars['String']['output']>;
  pairing_style?: Maybe<Scalars['String']['output']>;
  ph_background_image?: Maybe<Media>;
  ph_center_content?: Maybe<Scalars['Boolean']['output']>;
  ph_description?: Maybe<Scalars['String']['output']>;
  ph_show_follow_button?: Maybe<Scalars['Boolean']['output']>;
  ph_show_page_header?: Maybe<Scalars['Boolean']['output']>;
  ph_sponsored_by?: Maybe<PageHeaderSponsoredBy>;
  platform_id?: Maybe<Scalars['String']['output']>;
  primary_category?: Maybe<TermPost>;
  promo_description?: Maybe<Scalars['String']['output']>;
  promo_image?: Maybe<Scalars['String']['output']>;
  promo_image_focal_point?: Maybe<Point>;
  promo_title?: Maybe<Scalars['String']['output']>;
  rss_title?: Maybe<Scalars['String']['output']>;
  show_contributor_bios?: Maybe<Scalars['Boolean']['output']>;
  sponsor_logo?: Maybe<Media>;
  sponsor_url?: Maybe<Scalars['String']['output']>;
  sponsored_by?: Maybe<Scalars['String']['output']>;
  tempest_id?: Maybe<Scalars['ID']['output']>;
  trackonomics_disabled?: Maybe<Scalars['Boolean']['output']>;
  twitter_description?: Maybe<Scalars['String']['output']>;
  twitter_image?: Maybe<Scalars['String']['output']>;
  twitter_title?: Maybe<Scalars['String']['output']>;
  yahoo_title?: Maybe<Scalars['String']['output']>;
};

export type VideoOrExternalVideo = ExternalVideo | Video;

export type GetHtmlSitemapIndexQueryVariables = Exact<{
  siteId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHtmlSitemapIndexQuery = { __typename?: 'Query', index: Array<number> };

export type GetHtmlSitemapPostsQueryVariables = Exact<{
  siteId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  type: Html_Sitemap_Range_Type;
  date?: InputMaybe<Html_Sitemap_Range_Date>;
  timezone: Scalars['String']['input'];
}>;


export type GetHtmlSitemapPostsQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Author', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'LeftRail', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'Media', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'Newsletter', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'Numbrix', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'Page', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'Post', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'Recipe', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'TeamTermPost', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'TermPost', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> } | { __typename?: 'Video', type: string, site_id: number, title?: string | null, path?: string | null, authors: Array<{ __typename?: 'Author', guid: string, site_id: number, title?: string | null, path?: string | null }> }> };

export type GetXmlSitemapIndexQueryVariables = Exact<{
  siteId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
}>;


export type GetXmlSitemapIndexQuery = { __typename?: 'Query', index: Array<{ __typename?: 'Sitemap', loc: string, lastModified: string, totalPages: number }> };

export type GetXmlSitemapPostsQueryVariables = Exact<{
  siteId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
  loc: Scalars['String']['input'];
}>;


export type GetXmlSitemapPostsQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Author', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'LeftRail', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'Media', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'Newsletter', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'Numbrix', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'Page', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'Post', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'Recipe', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'TeamTermPost', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'TermPost', site_id: number, path?: string | null, modified_gmt: string } | { __typename?: 'Video', site_id: number, path?: string | null, modified_gmt: string }> };

export type GetGoogleNewsSitemapPostsQueryVariables = Exact<{
  siteId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  since: Scalars['DateTime']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGoogleNewsSitemapPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostConnection', edges: Array<{ __typename?: 'PostEdge', node: { __typename: 'Author', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'LeftRail', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'Media', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'Newsletter', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'Numbrix', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, meta: { __typename?: 'PostMeta', canonical_url?: string | null, meta_robots?: string | null }, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'Page', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'Post', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, meta: { __typename?: 'PostMeta', canonical_url?: string | null, meta_robots?: string | null }, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'Recipe', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'TeamTermPost', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'TermPost', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } | { __typename: 'Video', site_id: number, path?: string | null, title?: string | null, modified_gmt: string, featured_media?: { __typename?: 'Media', title?: string | null, caption?: string | null, source_url?: string | null } | null, terms: Array<{ __typename: 'Term' } | { __typename: 'TermPost', title?: string | null, taxonomy?: string | null }> } }> } };

export type GetPostsBySlugQueryVariables = Exact<{
  siteId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  slug: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetPostsBySlugQuery = { __typename?: 'Query', posts: { __typename?: 'PostConnection', edges: Array<{ __typename?: 'PostEdge', node: { __typename: 'Author', slug?: string | null, path?: string | null, type: string } | { __typename: 'LeftRail', slug?: string | null, path?: string | null, type: string } | { __typename: 'Media', slug?: string | null, path?: string | null, type: string } | { __typename: 'Newsletter', slug?: string | null, path?: string | null, type: string } | { __typename: 'Numbrix', slug?: string | null, path?: string | null, type: string } | { __typename: 'Page', slug?: string | null, path?: string | null, type: string } | { __typename: 'Post', slug?: string | null, path?: string | null, type: string } | { __typename: 'Recipe', slug?: string | null, path?: string | null, type: string } | { __typename: 'TeamTermPost', slug?: string | null, path?: string | null, type: string } | { __typename: 'TermPost', slug?: string | null, path?: string | null, type: string } | { __typename: 'Video', slug?: string | null, path?: string | null, type: string } }> } };

export type GetPostsByPathsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  paths: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetPostsByPathsQuery = { __typename?: 'Query', posts: { __typename?: 'PostConnection', edges: Array<{ __typename?: 'PostEdge', node: { __typename?: 'Author', path?: string | null } | { __typename?: 'LeftRail', path?: string | null } | { __typename?: 'Media', path?: string | null } | { __typename?: 'Newsletter', path?: string | null } | { __typename?: 'Numbrix', path?: string | null } | { __typename?: 'Page', path?: string | null } | { __typename?: 'Post', path?: string | null } | { __typename?: 'Recipe', path?: string | null } | { __typename?: 'TeamTermPost', path?: string | null } | { __typename?: 'TermPost', path?: string | null } | { __typename?: 'Video', path?: string | null } }> } };

export type SearchPostsQueryVariables = Exact<{
  siteId: Scalars['Int']['input'];
  keyword: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPostsQuery = { __typename?: 'Query', posts: { __typename?: 'PostConnection', total: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PostEdge', node: { __typename: 'Author', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'LeftRail', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'Media', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'Newsletter', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'Numbrix', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, meta: { __typename: 'PostMeta', is_sponsored?: boolean | null, promo_image?: string | null, sponsored_by?: string | null, primary_category?: { __typename?: 'TermPost', site_id: number, title?: string | null, path?: string | null } | null, promo_image_focal_point?: { __typename?: 'Point', x?: number | null, y?: number | null } | null }, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'Page', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'Post', ID: number, site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, meta: { __typename: 'PostMeta', is_sponsored?: boolean | null, promo_image?: string | null, sponsored_by?: string | null, primary_category?: { __typename?: 'TermPost', site_id: number, title?: string | null, path?: string | null } | null, promo_image_focal_point?: { __typename?: 'Point', x?: number | null, y?: number | null } | null }, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'Recipe', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, meta: { __typename: 'RecipeMeta', is_sponsored?: boolean | null, promo_image?: string | null, sponsored_by?: string | null, primary_category?: { __typename?: 'TermPost', site_id: number, title?: string | null, path?: string | null } | null, promo_image_focal_point?: { __typename?: 'Point', x?: number | null, y?: number | null } | null }, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'TeamTermPost', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'TermPost', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } | { __typename: 'Video', site_id: number, path?: string | null, title?: string | null, excerpt?: string | null, type: string, date_gmt: string, authors: Array<{ __typename?: 'Author', title?: string | null }> } }> } };

export type PostMetaFieldsFragment = { __typename: 'PostMeta', is_sponsored?: boolean | null, promo_image?: string | null, sponsored_by?: string | null, primary_category?: { __typename?: 'TermPost', site_id: number, title?: string | null, path?: string | null } | null, promo_image_focal_point?: { __typename?: 'Point', x?: number | null, y?: number | null } | null };

export type RecipeMetaFieldsFragment = { __typename: 'RecipeMeta', is_sponsored?: boolean | null, promo_image?: string | null, sponsored_by?: string | null, primary_category?: { __typename?: 'TermPost', site_id: number, title?: string | null, path?: string | null } | null, promo_image_focal_point?: { __typename?: 'Point', x?: number | null, y?: number | null } | null };

export const PostMetaFieldsFragmentDoc = gql`
    fragment postMetaFields on PostMeta {
  __typename
  is_sponsored
  primary_category {
    site_id
    title
    path
    term_id
  }
  promo_image
  promo_image_focal_point {
     x
    y
  }
  sponsored_by
}
    `;
export const RecipeMetaFieldsFragmentDoc = gql`
    fragment recipeMetaFields on RecipeMeta {
  __typename
  is_sponsored
  primary_category {
    site_id
    title
    path
  }
  promo_image
  promo_image_focal_point {
    x
    y
  }
  sponsored_by
}
    `;
export const GetHtmlSitemapIndexDocument = gql`
    query getHtmlSitemapIndex($siteId: [Int!]!, $timezone: String!, $year: Int, $month: Int) {
  index: htmlSitemapIndex(
    siteId: $siteId
    timezone: $timezone
    year: $year
    month: $month
  )
}
    `;
export const GetHtmlSitemapPostsDocument = gql`
    query getHtmlSitemapPosts($siteId: [Int!]!, $type: HTML_SITEMAP_RANGE_TYPE!, $date: HTML_SITEMAP_RANGE_DATE, $timezone: String!) {
  posts: htmlSitemapPosts(
    siteId: $siteId
    type: $type
    date: $date
    timezone: $timezone
  ) {
    type
    site_id
    title
    path
    authors {
      guid
      site_id
      title
      path
    }
  }
}
    `;
export const GetXmlSitemapIndexDocument = gql`
    query getXmlSitemapIndex($siteId: [Int!]!, $timezone: String!) {
  index: xmlSitemapIndex(siteId: $siteId, timezone: $timezone) {
    loc
    lastModified
    totalPages
  }
}
    `;
export const GetXmlSitemapPostsDocument = gql`
    query getXmlSitemapPosts($siteId: [Int!]!, $timezone: String!, $loc: String!) {
  posts: xmlSitemapPosts(siteId: $siteId, timezone: $timezone, loc: $loc) {
    site_id
    path
    modified_gmt
  }
}
    `;
export const GetGoogleNewsSitemapPostsDocument = gql`
    query getGoogleNewsSitemapPosts($siteId: [Int!]!, $since: DateTime!, $first: Int = 5000) {
  posts(
    filter: {where: {siteId: $siteId, status: ["publish"], postType: ["post", "numbrix"], syndication: [GOOGLE_NEWS], excludeSponsored: true, dateRange: {field: modified_gmt, from: $since}}, orderby: {field: modified_gmt, order: desc}}
    first: $first
  ) {
    edges {
      node {
        __typename
        site_id
        path
        title
        modified_gmt
        featured_media {
          title
          caption
          source_url
        }
        terms {
          __typename
          ... on TermPost {
            title
            taxonomy
          }
        }
        ... on Post {
          meta {
            canonical_url
            meta_robots
          }
        }
        ... on Numbrix {
          meta {
            canonical_url
            meta_robots
          }
        }
      }
    }
  }
}
    `;
export const GetPostsBySlugDocument = gql`
    query getPostsBySlug($siteId: [Int!]!, $slug: [String!]!) {
  posts(
    filter: {where: {siteId: $siteId, slug: $slug, status: ["publish"]}, orderby: {field: modified_gmt, order: desc}}
    first: 10
  ) {
    edges {
      node {
        __typename
        slug
        path
        type
      }
    }
  }
}
    `;
export const GetPostsByPathsDocument = gql`
    query getPostsByPaths($siteId: Int!, $paths: [String!]!) {
  posts(
    filter: {where: {siteId: [$siteId], path: $paths, status: ["publish"]}}
    first: 10
  ) {
    edges {
      node {
        path
      }
    }
  }
}
    `;
export const SearchPostsDocument = gql`
    query searchPosts($siteId: Int!, $keyword: String!, $first: Int = 12, $offset: Int = 0) {
  posts(
    filter: {where: {siteId: [$siteId], postType: ["post", "recipe", "numbrix"], status: ["publish"]}, search: {query: $keyword, profile: SITE_SEARCH}, orderby: {field: score, order: desc}}
    first: $first
    offset: $offset
  ) {
    total
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        __typename
        post_id
        authors {
          title
        }
        site_id
        path
        title
        excerpt
        type
        date_gmt
        ... on Numbrix {
          meta {
            ...postMetaFields
          }
        }
        ... on Post {
          meta {
            ...postMetaFields
          }
        }
        ... on Recipe {
          meta {
            ...recipeMetaFields
          }
        }
      }
    }
  }
}
    ${PostMetaFieldsFragmentDoc}
${RecipeMetaFieldsFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getHtmlSitemapIndex(variables: GetHtmlSitemapIndexQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHtmlSitemapIndexQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHtmlSitemapIndexQuery>(GetHtmlSitemapIndexDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getHtmlSitemapIndex', 'query', variables);
    },
    getHtmlSitemapPosts(variables: GetHtmlSitemapPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHtmlSitemapPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHtmlSitemapPostsQuery>(GetHtmlSitemapPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getHtmlSitemapPosts', 'query', variables);
    },
    getXmlSitemapIndex(variables: GetXmlSitemapIndexQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetXmlSitemapIndexQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetXmlSitemapIndexQuery>(GetXmlSitemapIndexDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getXmlSitemapIndex', 'query', variables);
    },
    getXmlSitemapPosts(variables: GetXmlSitemapPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetXmlSitemapPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetXmlSitemapPostsQuery>(GetXmlSitemapPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getXmlSitemapPosts', 'query', variables);
    },
    getGoogleNewsSitemapPosts(variables: GetGoogleNewsSitemapPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetGoogleNewsSitemapPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGoogleNewsSitemapPostsQuery>(GetGoogleNewsSitemapPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getGoogleNewsSitemapPosts', 'query', variables);
    },
    getPostsBySlug(variables: GetPostsBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPostsBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPostsBySlugQuery>(GetPostsBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPostsBySlug', 'query', variables);
    },
    getPostsByPaths(variables: GetPostsByPathsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPostsByPathsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPostsByPathsQuery>(GetPostsByPathsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPostsByPaths', 'query', variables);
    },
    searchPosts(variables: SearchPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchPostsQuery>(SearchPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchPosts', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;
